import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getColorCode } from '../../../api/color';
// Material Imports
import Grid from '@material-ui/core/Grid';
import { Card } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
// Redux imports
import {
  dateFormat,
  checkIfDateIsTodaysDate,
  checkIfDateIsUpcoming,
  getYear
} from '../../../api/dateFormat';
import { fetchDashboardData } from '../../../actions/dashboardActions';
import { digitalClassList } from '../../../actions/digitalClassActions';
import {
  listClassMaterial,
  listClassMaterialDetails
} from '../../../actions/classMaterialsActions';
import {
  noticeBoardList,
  noticeBoardDetail
} from '../../../actions/noticeboardActions';
import { examCalendarList } from '../../../actions/regularExamActions';
import { batchClassSchedule } from '../../../actions/batchClassActions';
import {
  digitalLiveClassRequest,
  liveClassPlayerRequest
} from '../../../actions/digitalLiveClassActions';
import {
  studentDownloadlist,
  studentDownloadFile
} from '../../../actions/downloadActions';
// Components
import DigitalClassroomLayout from '../DigitalClassroomStack/DigitalClassLayout';
import Textmessages from '../TextMessages';
// Global Components
import TimerCard from '../../../components/TimerCard';
import NoData from '../../../components/NoData';
//import Navigation from '../../../components/Navigation';
import ChapterCard from '../../../components/DataTextCard/Card';
import LoadingSkeleton from '../../../components/LoadingSkeleton';
import { openSnackBar } from '../../../actions/snackbarAction';
import PopUpModal from '../../../components/PopUpModal';
// Styles
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../HomePage/styles.scss';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%'
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%'
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '50%'
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%'
    }
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px'
  }
}));
export default function HomePage() {
  const childRef = useRef();
  const classes = useStyles();
  // * State
  const [batchClassArr, setBatchClassArr] = useState([]);
  const [uniqueCode, setUniqueCode] = useState('');

  // State
  const [popupHeader, setPopupHeader] = useState(<div>Notice</div>);
  const [popupBody, setPopupBody] = useState('');
  //   Reducers
  // loaders states
  const [isBatchFetching, setIsBatchFetching] = useState(false);
  const [isHomepageFetching, setIsHomepageFetching] = useState(false);
  const [isClassMaterialFetching, setIsClassMaterialFetching] = useState(false);
  const [isDigitalClassFetching, setIsDigitalClassFetching] = useState(false);
  const [isExamCalendarFetching, setIsExamCalendarFetching] = useState(false);
  const [isLiveClassFetching, setIsLiveClassFetching] = useState(false);
  const [isDownloadListFetching, setIsDownloadListFetching] = useState(false);
  const [isDownloadDataFetching, setIsDownloadDataFetching] = useState(false);
  const [isNoticeFetching, setIsNoticeFetching] = useState(false);

  // * Redux
  const dispatch = useDispatch();
  const loginData = useSelector(state =>
    get(state, 'loginReducer.data.jwt', {})
  );
  // slider data
  const homepageData = useSelector(state =>
    get(state, 'homepageReducer.data', {})
  );

  //text messages
  const textMessageList = useSelector(state =>
    get(state, 'textMessageReducer.data', {})
  );

  // batch class
  const batchClassData = useSelector(state =>
    get(state, 'batchClassReducer.data', {})
  );
  const errorMessageBatchClass = useSelector(state =>
    get(state, 'batchClassReducer.errorMessage', '')
  );

  // digital classroom
  const digitalClassListData = useSelector(state =>
    get(state, 'digitalClassReducer.data', {})
  );
  const errorMessageDigitalClass = useSelector(state =>
    get(state, 'digitalClassReducer.errorMessage', '')
  );

  // class material
  const classMaterialData = useSelector(state =>
    get(state, 'classMaterialReducer.data.listClass', [])
  );
  const classMaterial = useSelector(state =>
    get(state, 'classMaterialReducer.classMaterialDetails', [])
  );
  /*const classMaterialDetails = useSelector((state) =>
    get(state, 'classMaterialReducer.classMaterialDetails.listNotes', [])
  );*/
  const errorMessageClassMaterial = useSelector(state =>
    get(state, 'classMaterialReducer.errorMessage', '')
  );

  // exam calendar
  const examCalendarData = useSelector(state =>
    get(state, 'regularExamReducer.data', [])
  );
  const errorMessageExamCalendar = useSelector(state =>
    get(state, 'regularExamReducer.errorMessage', '')
  );

  // digital live class
  const profile = useSelector(state =>
    get(state, 'loginReducer.data.profile', '')
  );
  const digitalLiveClassListData = useSelector(state =>
    get(state, 'digitalLiveClassReducer.data', [])
  );
  const errorMessageLiveClass = useSelector(state =>
    get(state, 'digitalLiveClassReducer.errorMessage', '')
  );

  // Downloads
  const downloadList = useSelector(state =>
    get(state, 'downloadReducer.data', [])
  );
  const downloadDetails = useSelector(state =>
    get(state, 'downloadReducer.downloadDetails.listDownloadFile', [])
  );
  const errorMessageDownloads = useSelector(state =>
    get(state, 'downloadReducer.errorMessage', '')
  );

  // Notice Board
  const noticeList = useSelector(state =>
    get(state, 'noticeboardReducer.data', {})
  );
  const errorMessageNotice = useSelector(state =>
    get(state, 'noticeboardReducer.errorMessage', '')
  );

  // API calls for various sections based on data available
  useEffect(() => {
    if (batchClassData && Object.keys(batchClassData).length == 0) {
      setIsBatchFetching(true);
      batchClassSchedule(loginData, dispatch).then(() => {
        setIsBatchFetching(false);
      });
    }
    if (homepageData && Object.keys(homepageData).length == 0) {
      setIsHomepageFetching(true);
      fetchDashboardData(loginData, dispatch).then(() => {
        setIsHomepageFetching(false);
      });
    }
    if (digitalClassListData && Object.keys(digitalClassListData).length == 0) {
      setIsDigitalClassFetching(true);
      digitalClassList(loginData, dispatch).then(() => {
        setIsDigitalClassFetching(false);
      });
    }
    if (classMaterialData && Object.keys(classMaterialData).length == 0) {
      setIsClassMaterialFetching(true);
      listClassMaterial(loginData, dispatch).then(() => {
        setIsClassMaterialFetching(false);
      });
    }
    if (examCalendarData && Object.keys(examCalendarData).length == 0) {
      setIsExamCalendarFetching(true);
      examCalendarList(loginData, dispatch).then(() => {
        setIsExamCalendarFetching(false);
      });
    }
    if (downloadList && Object.keys(downloadList).length == 0) {
      setIsDownloadListFetching(true);
      studentDownloadlist(loginData, dispatch).then(() => {
        setIsDownloadListFetching(false);
      });
    }
    if (noticeList && Object.keys(noticeList).length == 0) {
      setIsNoticeFetching(true);
      noticeBoardList(loginData, dispatch).then(() => {
        setIsNoticeFetching(false);
      });
    }

    // if (Object.keys(digitalLiveClassListData).length == 0) {
    setIsLiveClassFetching(true);
    digitalLiveClassRequest(
      loginData,
      profile.EmpCode ? true : false,
      dispatch
    ).then(() => {
      setIsLiveClassFetching(false);
    });
    // }
  }, []);

  useEffect(() => {
    if (batchClassData && batchClassData.length > 0) {
      setTimeLineData();
    }
  }, [batchClassData]);

  useEffect(() => {
    if (uniqueCode) {
      // setIsClassMaterialFetching(true);
      listClassMaterialDetails(uniqueCode, loginData, dispatch).then(() => {
        // setIsClassMaterialFetching(false);
      });
    }
  }, [uniqueCode]);

  const onLiveRefresh = React.useCallback(() => {
    setIsLiveClassFetching(true);
    digitalLiveClassRequest(
      loginData,
      profile.EmpCode ? true : false,
      dispatch
    ).then(() => {
      populateDigitalLiveClass();
      setIsLiveClassFetching(false);
    });
  });

  // const navigationIcon = () => {
  //   return <Navigation />;
  // };

  //Digital Classroom

  const populatedigitalClassList = () => {
    return <DigitalClassroomLayout heading={false} totalCard={4} />;
  };

  //Classroom Material

  const handleUniqueCode = code => {
    setUniqueCode(code);
  };

  const handleDetailFetching = code => {
    setIsDownloadDataFetching(true);
    studentDownloadFile(code, loginData, dispatch).then(() => {
      setIsDownloadDataFetching(false);
    });
  };

  const dataList = () => {
    const list = [];
    if (!isEmpty(classMaterial) && classMaterial.listNotes.length > 0)
      classMaterial.listNotes.map((data, index) => {
        list.push(
          <React.Fragment key={index}>
            <a href={data.Value} target="_blank" rel="noopener noreferrer">
              <ListItem button key={index}>
                <ListItemText primary={data.Text} />
                <span className="icon-view">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 50 50"
                    fill="currentColor"
                    width="20"
                  >
                    <path d="M47.81,24.09c-.41-.46-10.35-11.3-22.81-11.3S2.6,23.63,2.19,24.09a1.35,1.35,0,0,0,0,1.82c.41.46,10.35,11.3,22.81,11.3s22.4-10.84,22.81-11.3A1.35,1.35,0,0,0,47.81,24.09ZM25,34.5A9.5,9.5,0,1,1,34.5,25,9.51,9.51,0,0,1,25,34.5Z" />
                    <path d="M26.36,22.29A4,4,0,0,1,28.07,19a6.78,6.78,0,1,0,3.6,7.16A4,4,0,0,1,26.36,22.29Z" />
                  </svg>
                </span>
              </ListItem>
            </a>
            <Divider />
          </React.Fragment>
        );
      });
    return list;
  };

  const populateClassMaterial = () => {
    const list = [];
    classMaterialData.some((data, index) => {
      if (index < 4) {
        list.push(
          <Grid item xs={12} sm={6} md={3}>
            <ChapterCard
              topic={data.ClassTitle.substr(data.ClassTitle.indexOf('|') + 2)}
              date={dateFormat(data.ClassDate)}
              handler={() => {
                handleUniqueCode(data.UniqueCode);
              }}
              uniqueCode={index.toString()}
              subject={data.SubjectName}
              list={dataList()}
              headerText={'Class Material'}
              showSubjectName={true}
            />
          </Grid>
        );
      }
    });
    return list;
  };
  // Notice Board
  const populateNoticeList = () => {
    const list = [];
    const whenLoading = [1, 1];
    isNoticeFetching
      ? whenLoading.map((item, index) => {
          list.push(
            <div className="notice-list" index={`${item}-${index}`}>
              <Skeleton className="notice-date" />
              <Skeleton
                className="flex-column flex-justify-center ml-20"
                width="20%"
              />
            </div>
          );
        })
      : !isEmpty(noticeList) &&
        noticeList.map((data, index) => {
          if (index < 2)
            return list.push(
              <div
                className="notice-list"
                onClick={() => {
                  noticeBoardDetail(loginData, data.UniqueCode, dispatch).then(
                    noticeDetail => {
                      setPopupHeader(
                        get(noticeDetail, 'data.NoticeTitle', <div>Notice</div>)
                      );
                      setPopupBody(
                        <div className="iframe-responsive">
                          {get(noticeDetail, 'data.PictureURL', '') ? (
                            <img
                              src={get(noticeDetail, 'data.PictureURL', '')}
                            />
                          ) : (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: get(
                                  noticeDetail,
                                  'data.NoticeDescription',
                                  ''
                                )
                              }}
                              className="height-100"
                            />
                          )}
                        </div>
                      );
                      childRef.current.handleClickOpen();
                    }
                  );
                }}
              >
                <div className="notice-date">
                  <span className="day">{handleMonth(data.NoticeDate)}</span>
                  <span className="date">{handleDay(data.NoticeDate)}</span>
                </div>
                <div className="flex-column flex-justify-center ml-20">
                  <div className="title">{data.NoticeTitle}</div>
                </div>
              </div>
            );
        });
    return list;
  };
  const handleMonth = date => {
    let dateString = dateFormat(date);
    return dateString.substr(3, 3);
  };
  const handleDay = date => {
    let dateString = dateFormat(date);
    return dateString.substr(0, 2);
  };
  // Downloads

  const populateDownloadList = () => {
    let list = [];
    let cardsToPopulate = 2;
    if (!isEmpty(downloadList))
      downloadList.map((data, index) => {
        return (
          index < cardsToPopulate &&
          list.push(
            <div
              topic={data.DownloadTItle}
              key={index}
              date={dateFormat(data.DownloadDate)}
              uniqueCode={data.UniqueCode}
              handler={() => {
                handleDetailFetching(data.UniqueCode);
              }}
              list={dataListDownloads()}
              headerText="Downloads"
            ></div>
          )
        );
      });
    const listToRender = chapterCardList(list);
    return listToRender;
  };
  const chapterCardList = listToRender => {
    const array = listToRender;
    const list = [];
    array.map((data, index) => {
      let topicName = get(data, 'props.topic', '');
      list.push(
        <Grid item xs={12} sm={12} md={12} key={index}>
          <ChapterCard
            topic={topicName.substr(topicName.indexOf('|') + 1)}
            date={data.props.date}
            handler={data.props.handler}
            uniqueCode={data.props.uniqueCode}
            subject={listToRender.subject}
            list={data.props.list}
            headerText={data.props.headerText}
            homepage={true}
          />
        </Grid>
      );
    });
    return list;
  };

  const dataListDownloads = () => {
    const array = isDownloadDataFetching
      ? [1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
      : downloadDetails;
    const list = [];
    !isEmpty(array) &&
      array.map((data, index) => {
        list.push(
          <a
            href={data.DownloadFileURL}
            target="_blank"
            rel="noopener noreferrer"
            download
            key={index}
          >
            <ListItem button>
              <ListItemText
                primary={
                  isDownloadDataFetching ? (
                    <Skeleton width="70%" />
                  ) : (
                    data.DownloadFileTitle
                  )
                }
              />
              {!isDownloadDataFetching && (
                <span className="icon-view">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 50 50"
                    fill="currentColor"
                    width="20"
                  >
                    <path d="M47.81,24.09c-.41-.46-10.35-11.3-22.81-11.3S2.6,23.63,2.19,24.09a1.35,1.35,0,0,0,0,1.82c.41.46,10.35,11.3,22.81,11.3s22.4-10.84,22.81-11.3A1.35,1.35,0,0,0,47.81,24.09ZM25,34.5A9.5,9.5,0,1,1,34.5,25,9.51,9.51,0,0,1,25,34.5Z" />
                    <path d="M26.36,22.29A4,4,0,0,1,28.07,19a6.78,6.78,0,1,0,3.6,7.16A4,4,0,0,1,26.36,22.29Z" />
                  </svg>
                </span>
              )}
            </ListItem>
          </a>
        );
      });
    return list;
  };

  //Batch Class Schedule

  const setTimeLineData = () => {
    let lectureArr = [];
    batchClassData.map(item => {
      if (
        item.classDetail &&
        item.classTime &&
        item.classDetail.length > 0 &&
        Object.keys(item.classTime).length > 0
      ) {
        item.classDetail.map(obj => {
          if (checkIfDateIsTodaysDate(obj.ClassDate)) {
            let list = prepareArrForGivenDate(obj, item.classTime);
            lectureArr.push(...list);
          }
        });
      }
    });
    setBatchClassArr(lectureArr);
  };

  const prepareArrForGivenDate = (obj, classTimeObj) => {
    let arr = [];
    if (obj && Object.keys(obj).length > 0) {
      for (let i = 0; i < Object.keys(obj).length; i++) {
        let lect_key = Object.keys(obj)[i] + '';
        if (obj[lect_key] && lect_key.includes('Lec_')) {
          arr.push({
            time: classTimeObj[lect_key],
            title: obj[lect_key],
            ClassDate: obj.ClassDate,
            description: ''
          });
        }
      }
    }
    return arr;
  };

  const populateBatchClass = () => {
    const list = [];
    batchClassArr.map((data, index) => {
      list.push(
        <React.Fragment key={index}>
          <li key={index} className="timeline-item">
            <h4>{data.title}</h4>
            <div className="time">{data.time}</div>
          </li>
        </React.Fragment>
      );
    });
    return <ul>{list}</ul>;
  };

  //Regular Exam Calendar

  const compareDate = mydate => {
    let q = new Date();
    let m = q.getMonth();
    let d = q.getDate();
    let y = q.getFullYear();

    let date = new Date(y, m, d);
    let xdate = new Date(mydate);
    const isSameDay = (a, b) => {
      return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
      );
    };
    if (isSameDay(date, xdate) === true) {
      return 'Today';
    } else if (date < xdate) {
      return 'Upcoming';
    } else {
      return 'Past';
    }
  };

  const populateExamCal = () => {
    var flag = false;
    var i = 0;
    const data = examCalendarData.filter(el => {
      return compareDate(el.TestDate) !== 'Past';
    });
    if (!isEmpty(data) && data[1])
      while (i < data.length - 1) {
        if (getYear(data[i].TestDate) !== getYear(data[i + 1].TestDate)) {
          flag = true;
          break;
        }
        i = i + 1;
      }
    const list = [];
    examCalendarData.some((data, index) => {
      if (
        compareDate(data.TestDate) === 'Upcoming' ||
        compareDate(data.TestDate) === 'Today'
      )
        list.push(
          <Link to={`/regular-exam-calendar#${data.TestID}`} key={index}>
            <div className="exam-list">
              <div
                className="exam-date"
                style={{
                  backgroundColor:
                    compareDate(data.TestDate) === 'Today'
                      ? '#ef7f27'
                      : compareDate(data.TestDate) === 'Past'
                      ? '#e4e4e4'
                      : compareDate(data.TestDate) === 'Upcoming'
                      ? '#2a2a2a'
                      : '',
                  color:
                    compareDate(data.TestDate) === 'Today'
                      ? '#fff'
                      : compareDate(data.TestDate) === 'Past'
                      ? '#2a2a2a'
                      : compareDate(data.TestDate) === 'Upcoming'
                      ? '#fff'
                      : ''
                }}
              >
                {!flag
                  ? data.TestDate.substr(
                      0,
                      data.TestDate.indexOf(' ', data.TestDate.indexOf(' ') + 1)
                    )
                  : data.TestDate}
              </div>
              <div className="flex-column flex-justify-center ml-10">
                <div className="exam-name-text">{data.TestName}</div>
                <div className="exam-time-text">({data.TimeDetail})</div>
              </div>
            </div>
          </Link>
        );
    });
    return list;
  };

  //Live Class

  const fetchLiveURL = async uniqueCode => {
    try {
      liveClassPlayerRequest(
        loginData,
        profile.EmpCode ? true : false,
        uniqueCode,
        dispatch
      ).then(res => {
        window.open(res.data.ClassURL);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getListClassData = () => {
    let todaysClass = false;
    let classToDisplay = [];
    digitalLiveClassListData.map(data => {
      if (checkIfDateIsTodaysDate(data.ClassDate)) {
        todaysClass = true;
        classToDisplay = data.listClass;
      }
    });
    if (todaysClass === false) {
      digitalLiveClassListData.map(item => {
        if (
          !isEmpty(item.ClassDate) &&
          checkIfDateIsUpcoming(item.ClassDate) &&
          !isEmpty(item.listClass)
        ) {
          item.listClass.map(data => {
            classToDisplay.length < 4 && classToDisplay.push(data);
          });
        }
      });
    }
    return classToDisplay;
  };

  const populateDigitalLiveClass = () => {
    const list = [];
    const classToDisplay = !isEmpty(digitalLiveClassListData)
      ? getListClassData()
      : [];
    const classList = [];
    if (!isEmpty(digitalLiveClassListData) && !isEmpty(classToDisplay))
      classToDisplay.map((classData, classIndex) => {
        let uniqueCode = classIndex;
        return classList.push(
          <React.Fragment key={classData.RemainingTime}>
            <TimerCard
              index={uniqueCode}
              key={uniqueCode}
              subject={classData.SubjectName}
              dateTime={`${classData.ClassStart} - ${classData.ClassEnd}`}
              topic={classData.ModuleNo}
              handler={() => {
                if (classData.RemainingTime < 0) {
                  fetchLiveURL(classData.UniqueCode);
                } else {
                  dispatch(
                    openSnackBar({
                      message: 'This live class is yet to start, please wait',
                      severity: 'warning'
                    })
                  );
                }
              }}
              start={classData.RemainingTime < 0 ? 'EXPIRE IN' : 'START IN'}
              initialTime={
                classData.RemainingTime < 0
                  ? classData.Expiry * 1000
                  : classData.RemainingTime * 1000
              }
              callback={onLiveRefresh}
              bottomColor={getColorCode(
                get(classData, 'ClassCode', '').replace('bg-', '')
              )}
              variant="smallcard"
            />
          </React.Fragment>
        );
      });
    list.push(
      <React.Fragment>
        {!isEmpty(classList) ? (
          classList
        ) : (
          <Card elevation={0} className="card content-card">
            <NoData
              message={'As of now, No Live Class is scheduled for your batch'}
            />
          </Card>
        )}
      </React.Fragment>
    );

    return list;
  };

  const getSlider = () => {
    const sliderImage = [];
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows: true,
      fade: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false
          }
        }
      ]
    };

    homepageData.slider.map((data, index) => {
      return sliderImage.push(
        <div className="slide" key={index}>
          <img src={data.value} alt={data.title} className="img-responsive" />
          {/* <div className="caption">
            <h3>{data.title}</h3>
          </div> */}
        </div>
      );
    });

    return <Slider {...settings}>{sliderImage}</Slider>;
  };
  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <div className="inner-wrapper inner-wrapper-home">
        <Grid item xs={12} className="pb-30">
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                <Card elevation={0} className="card content-card height-auto" >
                  <div className="banner">
                            {isHomepageFetching ? (
                              <div className="banner-loader">
                                <LoadingSkeleton type="image" height={300} />
                              </div>
                            ) : (
                              !isEmpty(homepageData) && getSlider()
                            )}
                    </div>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                <Card elevation={0} className="card content-card height-300" style={ {overflowY: textMessageList.length > 2 ? 'auto':'none'}}>
                    <Textmessages isHidden = {true} />
  
                  </Card>
                </Grid>
              </Grid>
            </Grid>

         
          <Grid item xs={12} className="pb-30">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3}>
                <Link to="/notices">
                  <div className="text-heading">
                    Latest <span> Notifications </span>
                  </div>
                </Link>
                <Card elevation={0} className="card content-card">
                  {!isEmpty(noticeList) || isNoticeFetching ? (
                    populateNoticeList()
                  ) : (
                    <NoData
                      message={
                        !isEmpty(errorMessageNotice)
                          ? errorMessageNotice
                          : 'No data Available'
                      }
                    />
                  )}
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
              <Link to="/digital-liveclass">
                  <div className="text-heading">
                    Live <span>Classes </span>
                  </div>
                </Link>
                {isLiveClassFetching ? (
                  <div className="card content-card live-card">
                    <LoadingSkeleton type="smallcard" />
                    <LoadingSkeleton type="smallcard" />
                  </div>
                ) : (
                  <Card
                    elevation={0}
                    className={`card content-card ${
                      !isEmpty(digitalLiveClassListData) ? 'live-card' : ''
                    }`}
                  >
                    {!isEmpty(digitalLiveClassListData) ? (
                      <PerfectScrollbar>
                        {populateDigitalLiveClass()}
                      </PerfectScrollbar>
                    ) : (
                      <NoData
                        message={
                          !isEmpty(errorMessageLiveClass)
                            ? errorMessageLiveClass
                            : 'No data Available'
                        }
                      />
                    )}
                  </Card>
                )}
                
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Link to="/download-material">
                  <div className="text-heading">DOWNLOADS</div>
                </Link>
                {isDownloadListFetching ? (
                  <>
                    <LoadingSkeleton type="downloads" />
                    <LoadingSkeleton type="downloads" />
                  </>
                ) : (
                  <>
                    {!isEmpty(downloadList) ? (
                      <Card elevation={0} className="card content-card">
                        <Grid container spacing={2} className="panel-body">
                          {populateDownloadList()}
                        </Grid>
                      </Card>
                    ) : (
                      <Card elevation={0} className="card content-card">
                        <NoData
                          message={
                            !isEmpty(errorMessageDownloads)
                              ? errorMessageDownloads
                              : 'No data Available'
                          }
                        />
                      </Card>
                    )}
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className="pb-30">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3}>
                <Link to="/batch-class-schedule">
                  <div className="text-heading">
                    Batch <span> Schedule </span>
                  </div>
                </Link>
                <Card className="card content-card batch-schedule-card">
                  {isBatchFetching ? (
                    <div className="mr-20 mt-20">
                      <LoadingSkeleton type="homeBatchlist" />
                    </div>
                  ) : !isEmpty(batchClassData) && batchClassArr.length > 0 ? (
                    <PerfectScrollbar>{populateBatchClass()}</PerfectScrollbar>
                  ) : (
                    <NoData
                      message={
                        !isEmpty(errorMessageBatchClass)
                          ? errorMessageBatchClass
                          : 'No data Available'
                      }
                    />
                  )}
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
              <Link to="/digital-classroom">
              <div className="text-heading">
                Your <span>Scheduled Classes </span>
              </div>
            </Link>
            <React.Fragment>
              {isDigitalClassFetching ? (
                <LoadingSkeleton type="bigcardlist" />
              ) : !isEmpty(digitalClassListData) ? (
                populatedigitalClassList()
              ) : (
                <Card className="card content-card">
                  <NoData
                    message={
                      !isEmpty(errorMessageDigitalClass)
                        ? errorMessageDigitalClass
                        : 'No data Available'
                    }
                  />
                </Card>
              )}
            </React.Fragment>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Link to="/regular-exam-calendar">
                  <div className="text-heading">
                    Upcoming <span> Exam </span>
                  </div>
                </Link>
                <Card elevation={0} className="card content-card reg-exam">
                  {isExamCalendarFetching ? (
                    <LoadingSkeleton type="homeExamList" />
                  ) : !isEmpty(examCalendarData) &&
                    !isEmpty(populateExamCal()) ? (
                    <PerfectScrollbar>{populateExamCal()}</PerfectScrollbar>
                  ) : (
                    <NoData
                      message={
                        !isEmpty(errorMessageExamCalendar)
                          ? errorMessageExamCalendar
                          : 'As of now, no Upcoming Exam is scheduled for your batch.'
                      }
                    />
                  )}
                </Card>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Link to="/classroom-material">
              <div className="text-heading">
                Latest <span>Course Material </span>
              </div>
            </Link>
            <React.Fragment>
              {isClassMaterialFetching ? (
                <div className="mr-20 mt-20">
                  <LoadingSkeleton type="smallcardlist" />
                </div>
              ) : !isEmpty(classMaterialData) ? (
                <Grid container spacing={2}>
                  {populateClassMaterial()}
                </Grid>
              ) : (
                <Card elevation={0} className="card content-card">
                  <NoData
                    message={
                      !isEmpty(errorMessageClassMaterial)
                        ? errorMessageClassMaterial
                        : 'As of now, No class Material is available for your Batch.'
                    }
                  />
                </Card>
              )}
            </React.Fragment>
          </Grid>
        </div>
      </Grid>
      <PopUpModal
        ref={childRef}
        data={[]}
        header={popupHeader}
        body={popupBody}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        fullScreen={true}
        className="full-content-popup"
      />
    </Grid>
  );
}
